import { inject, Injectable, Injector } from '@angular/core';
import { BitfKeycloakAuthService } from '@common/libs/bitforce/core/services/auth/keycloak/bitf-keycloak-auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BitfKeycloakAuthService {
  tokenAlertTresholdMinutes = 5;
  constructor() {
    const injector = inject(Injector);
    super(injector);
  }
}
